import { addHours, getMinutes, getHours, getSeconds } from 'date-fns'
import { format, addDays, parse, isSaturday, isSunday, isWeekend, getMonth, getYear, addWeeks, addMonths, addYears, formatDistance, differenceInCalendarDays, isDate, formatDistanceToNow} from 'date-fns'
import Utilities from '@/helpers/Utilities'
import NumberHelpers from '@/helpers/NumberHelpers'

export const dateFormats = Object.freeze( {
    BACKWARDS: 'yyyy-MM-dd',
    AUSTRALIAN: 'dd/MM/yy',
    DAY_ONLY: 'EEEE',
    TIME_ONLY: 'HH:mm',
    BACKWARDS_WITH_TIME: 'yyyy-MM-dd HH:mm',
    YEAR_MONTH: 'yyyy-MM'
} )

export default class {

    static expandYear(yr) {
        try {
            yr = parseInt(yr)
        } catch (e) {
            yr = getYear(new Date())
        }
        if(yr < 40)
            yr = 2000 + yr
        else if(yr < 100)
            yr = 1900 + yr
        else if(yr < 1900)
            yr = getYear(new Date())
        
        return yr
        
    }

    static toDate(anyFormat) {
        if(!anyFormat || anyFormat === true) {
            //console.log('toDate returns null')
            return null
        }

        if(isDate(anyFormat)) {
            //console.log('toDate returns the date passed in')
            return anyFormat
        }

        if(Utilities.isObject(anyFormat) && anyFormat.seconds) {
            //console.log('toDate is a firebase timestamp')
            return anyFormat.toDate()
        }
        
        if(anyFormat.length > 9 && anyFormat.charAt(4) == '-' && anyFormat.charAt(7) == '-')
            return this.backwardsToDate(anyFormat)

        let slashArr = anyFormat.toString().split('/')
        if(slashArr.length > 1) {
            const day = slashArr[0]
            const month = slashArr[1]
            let year = getYear(new Date())
            if(slashArr.length > 2)
                year = this.expandYear(slashArr[2])
            return new Date(year, month -1, day)
        }

        // if(anyFormat.length == 8 && anyFormat.charAt(2) == '/' && anyFormat.charAt(5) == '/')
        //     return parse(anyFormat, 'dd/MM/yy', new Date())

        return new Date(anyFormat)  
    }

    static businessDaysFromNow(days) {
        return this.businessDaysAdd(new Date(), days)
    }

    static businessDaysAdd(dt, days) {
        
        let inc = 1
        if(days < 0) {
            days = Math.abs(days)
            inc = -1
        }
        var i = 0
        while (i != days) {
            dt = addDays(dt, inc)
            if ( !isWeekend(dt) )
                i++
        }
        return dt
    }

    static timeAgo(anyDateFormat) {
        const date = this.toDate(anyDateFormat)
        if(!date)
            return 'Just now'
        return formatDistanceToNow(date) + ' ago'
    }

    static smartDaysFromNow(days) {
        if(!days)
            days = 0

        let dt
        if(days > 6)
            dt = this.bumpIfWeekend(
                addDays(new Date(), days)
            )
        else
            dt = this.businessDaysFromNow(days)

        return dt
    }

    static bumpIfWeekend(dt) {
        if(isSaturday(dt))
            return addDays(dt, 2)
        if(isSunday(dt))
            return addDays(dt, 1)
        return dt
    }
    
    static isToday(dateString) {
        let dt1 = new Date(dateString)
        let dt2 = new Date()
        return dt1.toDateString() == dt2.toDateString()
    }

    static tomorrowString() {
        const tomorrow = addDays(new Date(), 1)
        return format(tomorrow, dateFormats.BACKWARDS)
    }
    static yesterdayString() {
        const yesterday = addDays(new Date(), -1)
        return format(yesterday, dateFormats.BACKWARDS)
    }
 
    static todayString() {
        return format(new Date(), dateFormats.BACKWARDS)
    }

    static yearMonth(date = new Date()) {
        return format(date, dateFormats.YEAR_MONTH)
    }
    
    static timeString() {
        return format(new Date(), 'HH:mm')
    }

    static nowString(date = new Date()) {
        return format(date, dateFormats.BACKWARDS_WITH_TIME)
    }

    static auToBackwards(auString) {
        if(!auString)
            return ''
        let arr = auString.split('/')
        let dateObj = new Date(2000 + parseInt(arr[2]), arr[1] - 1, arr[0])
        return format(dateObj, dateFormats.BACKWARDS)
    }

    static dateToBackwards(dateObj) {
        if(!dateObj || !isDate(dateObj))
            return ''
        return format(dateObj, dateFormats.BACKWARDS)
    }

    static backwardsToAu(backwardsDateString) {
        if(!backwardsDateString)
            return ''
            
        let dateObj = new Date(backwardsDateString)
        return format(dateObj, 'dd/MM/yy')
    }

    static dateTimeToText(str) {
        let result
        if(!str)
            return '* No Time *'

        let arr = str.split(' ')
        let date = arr[0].trim()
        let dateObj = new Date(date)
        result = format(dateObj, 'EEEE dd/MM/yy')

        if(arr.length > 1){
            let time = arr[1].trim()
            result += ' at ' + time
        }
        return result

    }

    static backwardsToDate(dateStr) {
        if(!dateStr)
            return null
        const dateArr = dateStr.split('-')
        if(dateArr.length != 3)
            return null
        const y = parseInt(dateArr[0])
        const m = parseInt(dateArr[1]) - 1
        const d = parseInt(dateArr[2]) 
        
        return new Date(y,m,d)
    }

    static dateToAu(dt) {
        return format(dt, dateFormats.AUSTRALIAN)
    }

    static convertDate(dateString, fromFormat, toFormat) {
        let dt = parse(dateString, fromFormat, new Date())
        return format(dt, toFormat)
    }

    static findDayInString(str) {
        const returnObj = {
            found: false,
        }
        let matches = str.match(/\b(mon|tue|wed|thu|fri|sat|sun)\b/)
        if(!matches) {
            let matches = str.match(/\btoday\b/)
            if(!matches)
                return returnObj
            returnObj.found = true
            returnObj.words = 'today'
            returnObj.date = new Date()
            returnObj.remaining = str.replace('today', '').trim()
            return returnObj
        }
           
            
        const day = matches[0]
        for(var n = 1; n < 8; n++) {
            let dt = addDays(new Date(), n)
            let dayToTest = format(dt, 'EEEE').toLowerCase()
            if(dayToTest.startsWith(day)) {
                returnObj.found = true
                returnObj.date = dt
                returnObj.words = dayToTest
                returnObj.remaining = str.replace(day, '').trim()
            }
                
        }
        return returnObj            
    }

    static findDateInString(str) {
        const returnObj = {
            found: false,
        }
        let matches = str.match(/\d{1,2}\/\d{1,2}(\/\d{2,4})?/)
        if(!matches)
            return returnObj

        const dmyString = matches[0]
        const dmyArray = dmyString.split('/')

        let d, m, y
        [d,m,y] = dmyArray
        if(!y)
            y = getYear(new Date())

        y = parseInt(y)

        if(y < 50) 
            y = y + 2000
        else if(y < 100)
            y = 1900 + y
        

        if(y < 1950 || y > 2050)
            return returnObj

        if(m < 1 || m > 12)
            return returnObj
        
        if(d < 1 || d > 31)
            return returnObj



        const dt = new Date(y, m-1, d)
        if(!dt)
            return returnObj

        returnObj.found = true
        returnObj.date = dt
        returnObj.remaining = str.replace(dmyString, '').trim()
        returnObj.words = formatDistance(new Date(), dt)

        return returnObj
    }



    static findTimeframeInString(str, baseDate = new Date()) {

        //find date in format of dd/mm or dd/mm/yy
        let resultObj = this.findDateInString(str)
        if(resultObj.found) {
            return resultObj
        }

        //find day in format mon,tue,wed
        resultObj = this.findDayInString(str)
        if(resultObj.found)
            return resultObj

        //find period in format 2d, 3w, 4m, 5y
        let matches = str.match(/\s*\d+[dmwy]/)
        if(!matches)
            return {date: baseDate, words: 'today', remaining: str, found: false}

        let match = matches[0]
        let period = parseInt(match)
        let unit = match.match(/[a-z]/)
        let remainingString = str.replace(match, '').trim()
        let endDate
        let unitInWords 
   
        if(unit == 'd') {
            if(period > 6)
                endDate = addDays(baseDate, period)
            else
                endDate = this.businessDaysAdd(baseDate, period)
            unitInWords = 'days'
        }
        if(unit == 'w') {
            endDate = addWeeks(baseDate, period)
            unitInWords = 'weeks'
        }
        if(unit == 'm') {
            endDate = addMonths(baseDate, period)
            unitInWords = 'months'
        }
        if(unit == 'y') {
            endDate = addYears(baseDate, period)
            unitInWords = 'years'
        }

        return {
            remaining: remainingString,
            words: (period + ' ' + unitInWords),
            date: endDate,
            found: true,
        }
    }
    
    // replaced by findTimeframeInString above...

    // static stringToDate(str, baseDate = new Date()) {
 
    //         if(str == '')
    //             return null
            
    //         if(!parseInt(str)) {
    //             let dt = this.dateOfDay(str)
    //             if(dt)
    //                 return dt
    //         }
            
    //         //    dd/MM or dd/MM/yy or dd
    //         let dateArr = str.split('/')
    //         if(dateArr.length > 1) {     
    //             let day = parseInt(dateArr[0]) || 1
    //             let month = parseInt(dateArr[1]) || getMonth(new Date())
    //             let year = parseInt(dateArr[2]) || getYear(new Date())
        
    //             if(year < 50)
    //                 year = 2000 + year
    //             else if(year < 100)
    //                 year = 1900 + year

    //             let dateStr = day.toString() + '/' + month.toString() + '/' + year.toString()
    //             return new Date(year + '-' + month + '-' + day)
    //         }

    //         if(str.match(/\d+w/)) {
    //             let weeks = parseInt(str)
    //             return addWeeks(baseDate, weeks)
    //         }            

    //         if(str.match(/\d+m/)) {
    //             let months = parseInt(str)
    //             return addMonths(baseDate, months)
    //         }    
   
    //         if(str.match(/\d+d/)) {
    //             let days = parseInt(str)
    //             return addDays(baseDate, days)
    //         }    

    //         if(str.match(/\d+y/)) {
    //             let years = parseInt(str)
    //             return addYears(baseDate, years)
    //         }    

    //         return null   
    // }
     
    static dateOfDay(day) {
        day = day.toLowerCase()
        for(var n = 1; n < 8; n++) {
            let dt = addDays(new Date(), n)
            let dayToTest = format(dt, 'EEEE').toLowerCase()
            if(dayToTest.startsWith(day))
                return dt
        }
        return null
    } 
    
    static isValidDate(date) {
        return (
            date
            && Object.prototype.toString.call(date) === "[object Date]"
            && !isNaN(date) 
            && date > (new Date(1950, 1, 1) )
            && date < (new Date(2050, 1, 1) )
        )
    }

    static nextFiveWorkingDays() {

        let returnDates = []
        let i = 0
        while(returnDates.length < 5) {
            
            const date = addDays(new Date(), i)

            let day = {
                date: format(date, dateFormats.BACKWARDS),
                day: format(date, 'EEEE')
            }
            if(day.day != 'Saturday' && day.day != 'Sunday')
                returnDates.push(day)
            i++
        }
        return returnDates
    }

    static fromNow(anyFormat) {

        const date = this.toDate(anyFormat)

        if(!date)
            return ''

        if(!this.isValidDate(date) || date == 'Invalid Date') {
            console.error('fromNow was passed an invalid date', date)
        }

        let weekDay = format(date, 'EEEE')

        let days = differenceInCalendarDays(date, new Date())

        if(days == 0)
            return 'Today'
        else if(days == 1)
            return 'Tomorrow' 
        else if(days == -1)
            return 'Yesterday' 
        else if(days < 0)
            return Math.abs(days) + ' days ago'
        else if(days > 0 && days < 7)
            return weekDay
        else
            return 'In ' +  days + ' days'
    }

   

    static convertToDuration = (secondsAmount) => {
        const normalizeTime = (time) =>
        time.length === 1 ? `0${time}` : time

        const SECONDS_TO_MILLISECONDS_COEFF = 1000
        const MINUTES_IN_HOUR = 60

        const milliseconds = secondsAmount * SECONDS_TO_MILLISECONDS_COEFF

        const date = new Date(milliseconds);
        const timezoneDiff = date.getTimezoneOffset() / MINUTES_IN_HOUR
        const dateWithoutTimezoneDiff = addHours(date, timezoneDiff)

        const hours = normalizeTime(String(getHours(dateWithoutTimezoneDiff)))
        const minutes = normalizeTime(String(getMinutes(dateWithoutTimezoneDiff)))
        const seconds = normalizeTime(String(getSeconds(dateWithoutTimezoneDiff)))

        const hoursOutput = hours !== '00' ? `${hours}:` : ''

        return `${hoursOutput}${minutes}:${seconds}`
    }

}


// WEBPACK FOOTER //
// ./src/helpers/DateHelpers.js